import React, { useState } from "react";
import Table from "../../../../common/element/Table";
import Button from "../../../../common/element/Buttons";
import Checkbox from "../../../../common/element/Checkbox";
import { useNavigate } from "react-router-dom";
import AddEditSession from "./AddEdit";
import ArchiveModal from "../../../../common/Common/ArchiveModal";
import AddEditQuiz from "./AddEdit";
import DeleteModal from "../../../../common/Common/DeleteModal";

const { Tr, Th, Td, THead, TBody } = Table;

const QuizMasterList = () => {
  const [mode, setMode] = useState('add'); // 'add', 'edit', 'view'

  // Sample data for QuizMasterList component
  const handleEdit = (item) => {
    // setSelectedDocument(item);
    setMode('edit');
    setDialogOpen(true);
  };

  const sampleData = [
    {
      id: 1,
      quizName: "Feedback Quiz",
      totalQuestions: 10,
      questionTypes: "MCQ, Subjective",
      createdOn: "20 Sept 2025"
    },
    {
      id: 2,
      quizName: "Dummy Quiz",
      totalQuestions: 5,
      questionTypes: "Rating, Multi-select",
      createdOn: "19 Sept 2025"
    },
    {
      id: 3,
      quizName: "Dummy Quiz",
      totalQuestions: 2,
      questionTypes: "MCQ, Multi-select, Subjective",
      createdOn: "18 Sept 2025"
    },
    {
      id: 4,
      quizName: "Dummy Quiz",
      totalQuestions: 8,
      questionTypes: "MCQ, Subjective",
      createdOn: "17 Sept 2025"
    },
    {
      id: 5,
      quizName: "Dummy Quiz",
      totalQuestions: 6,
      questionTypes: "Rating, Multi-select",
      createdOn: "15 Sept 2025"
    },
    {
      id: 6,
      quizName: "Dummy Quiz",
      totalQuestions: 1,
      questionTypes: "MCQ, Multi-select, Subjective",
      createdOn: "13 Sept 2025"
    },
    {
      id: 7,
      quizName: "Dummy Quiz",
      totalQuestions: 7,
      questionTypes: "MCQ, Multi-select, Subjective",
      createdOn: "10 Sept 2025"
    }
  ];
  const [mainCheck, setMainCheck] = useState(false);
  const [checkedItems, setCheckedItems] = useState([]);
  const navigate = useNavigate();
  const [dialogOpen, setDialogOpen] = useState(false);
  const [selectedSession, setSelectedSession] = useState(null);
  const [isViewMode, setIsViewMode] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  const onCheckboxChange = (checked, item) => {
    if (item === "mainCheck") {
      setMainCheck(checked);
      setCheckedItems(checked ? sampleData : []);
    } else {
      if (checked) {
        setCheckedItems([...checkedItems, item]);
      } else {
        setCheckedItems(checkedItems.filter((i) => i.id !== item.id));
      }
    }
  };


  // Usage in your component:
  // import { sampleQuizData } from './path-to-this-file';
  // <QuizMasterList sampleData={sampleQuizData} />
  return (
    <>
      <div className="border rounded-lg border-gray-200">
        <Table>
          <THead>
            <Tr>
              <Th>S No.</Th>
              <Th>Quiz Name</Th>
              <Th>Total Questions</Th>
              <Th>Question Types</Th>
              <Th>Created On</Th>
              <Th>Action</Th>
            </Tr>
          </THead>

          <TBody>
            {sampleData.length > 0 ? (
              sampleData.map((item, index) => (
                <Tr key={item.id} className="text-start">
                  <Td className="text-start">{String(index + 1).padStart(2, "0")}</Td>
                  <Td className="text-start">{item.quizName}</Td>
                  <Td className="text-start">{item.totalQuestions}</Td>
                  <Td className="text-start">{item.questionTypes}</Td>
                  <Td className="text-start">{item.createdOn}</Td>
                  <Td className="text-start">
                    <div className="flex gap-2 justify-start">
                      {/* View Button */}
                      <Button className='p-[10px]' onClick={() => {
                       navigate("/quiz-master/quizView")
                      }}>
                       <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M2.01677 10.5942C1.90328 10.4145 1.84654 10.3246 1.81477 10.186C1.79091 10.0819 1.79091 9.91775 1.81477 9.81366C1.84654 9.67507 1.90328 9.58522 2.01677 9.40552C2.95461 7.92054 5.74617 4.1665 10.0003 4.1665C14.2545 4.1665 17.0461 7.92054 17.9839 9.40552C18.0974 9.58522 18.1541 9.67507 18.1859 9.81366C18.2098 9.91775 18.2098 10.0819 18.1859 10.186C18.1541 10.3246 18.0974 10.4145 17.9839 10.5942C17.0461 12.0791 14.2545 15.8332 10.0003 15.8332C5.74617 15.8332 2.95461 12.0791 2.01677 10.5942Z" stroke="#475467" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M10.0003 12.4998C11.381 12.4998 12.5003 11.3805 12.5003 9.99984C12.5003 8.61913 11.381 7.49984 10.0003 7.49984C8.61962 7.49984 7.50034 8.61913 7.50034 9.99984C7.50034 11.3805 8.61962 12.4998 10.0003 12.4998Z" stroke="#475467" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                      </Button>

                      {/* Edit Button */}
                      <Button className='p-[10px]' onClick={() => handleEdit(item)}>
                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M1.14735 14.1202C1.18564 13.7756 1.20478 13.6034 1.25691 13.4423C1.30316 13.2994 1.36851 13.1635 1.45118 13.0381C1.54436 12.8968 1.66694 12.7742 1.91209 12.5291L12.9173 1.52385C13.8378 0.603377 15.3302 0.603378 16.2507 1.52385C17.1711 2.44433 17.1711 3.93671 16.2507 4.85719L5.24542 15.8624C5.00027 16.1076 4.8777 16.2301 4.73639 16.3233C4.61102 16.406 4.47506 16.4713 4.33219 16.5176C4.17115 16.5697 3.99887 16.5889 3.65429 16.6272L0.833984 16.9405L1.14735 14.1202Z" stroke="#475467" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                      </Button>

                      {/* Delete Button */}
                      <Button className='p-[10px]' onClick={() => setIsOpen(true)}>
                      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M13.3333 4.99984V4.33317C13.3333 3.39975 13.3333 2.93304 13.1517 2.57652C12.9919 2.26292 12.7369 2.00795 12.4233 1.84816C12.0668 1.6665 11.6001 1.6665 10.6667 1.6665H9.33333C8.39991 1.6665 7.9332 1.6665 7.57668 1.84816C7.26308 2.00795 7.00811 2.26292 6.84832 2.57652C6.66667 2.93304 6.66667 3.39975 6.66667 4.33317V4.99984M8.33333 9.58317V13.7498M11.6667 9.58317V13.7498M2.5 4.99984H17.5M15.8333 4.99984V14.3332C15.8333 15.7333 15.8333 16.4334 15.5608 16.9681C15.3212 17.4386 14.9387 17.821 14.4683 18.0607C13.9335 18.3332 13.2335 18.3332 11.8333 18.3332H8.16667C6.76654 18.3332 6.06647 18.3332 5.53169 18.0607C5.06129 17.821 4.67883 17.4386 4.43915 16.9681C4.16667 16.4334 4.16667 15.7333 4.16667 14.3332V4.99984" stroke="#475467" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                      </Button>
                    </div>
                  </Td>
                </Tr>
              ))
            ) : (
              <Tr>
                <Td colSpan={6} className="text-center text-gray-500 py-6 text-sm">
                  No matching records found
                </Td>
              </Tr>
            )}
          </TBody>
        </Table>
      </div>
      <AddEditQuiz
        dialogOpen={dialogOpen}
        onDialogClose={() => {
          setDialogOpen(false);
          // setSelectedDocument(null);
        }}
        // documentData={selectedDocument}
        mode={mode}
      />
      {/* <ArchiveModal
        dialogOpen={isOpen}
        onDialogClose={() => setIsOpen(false)}
      /> */}
        <DeleteModal
        dialogOpen={isOpen}
        onDialogClose={() => setIsOpen(false)}
        onConfirm={() => setIsOpen(false)}
        title="Are you sure you want to delete?"
        subtitle="This action cannot be undone."
      />
    </>
  );
};

export default QuizMasterList;